import { useEffect, useState } from "react";
import { motion, useScroll, useSpring } from "framer-motion";

export const ScrollRail = ({ sections }) => {
  const [active, setActive] = useState(0);
  const { scrollYProgress } = useScroll();
  const progress = useSpring(scrollYProgress, { stiffness: 90, damping: 24, restDelta: 0.001 });

  useEffect(() => {
    const els = sections.map((s) => document.getElementById(s.id)).filter(Boolean);
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            const i = sections.findIndex((s) => s.id === e.target.id);
            if (i >= 0) setActive(i);
          }
        });
      },
      { threshold: 0.4 }
    );
    els.forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, [sections]);

  return (
    <>
      <motion.div className="cg-progress" style={{ scaleX: progress }} aria-hidden="true" />
      <nav className="cg-rail hidden lg:flex" aria-label="Section navigation" data-testid="scroll-rail">
        {sections.map((s, i) => (
          <button
            key={s.id}
            data-testid={`rail-dot-${s.id}`}
            data-cursor="GO"
            aria-label={s.label}
            onClick={() => document.getElementById(s.id)?.scrollIntoView({ behavior: "smooth" })}
            className={`cg-rail-dot ${active === i ? "is-active" : ""}`}
          >
            <span className="cg-rail-label">{s.label}</span>
          </button>
        ))}
      </nav>
    </>
  );
};
